import ContinueButton from "@/shared-components/buttons/components/ContinueButton";
import XIcon from "@/shared-components/icons/components/public/XIcon";
import GenericPopup from "@/shared-components/popups/components/GenericPopup";

import "./styles/PopupSelectTemplate.css";

const PopupSelectTemplate = ({ open,close,selectTemplate,setSelectedTemplate,onClick }) => {
  return (

    <GenericPopup
      open={open}
      className="artwork-options__download-template-container w-[30em] "
      opacity
      onTouchStart={(e) => e.stopPropagation()}
      onTouchEnd={(e) => e.stopPropagation()}
      onWheel={(e) => e.stopPropagation()}
    >
      <p className="artwork-options__download-template_header-text">
            Generate template
      </p>
      <p className="artwork-options__download-template_header-step-text">
        <span className="artwork-options__download-template_header-step-text-span">
              1.{" "}
        </span>
            Choose a template format
      </p>
      <XIcon
        className="artwork-options__download-template_header-Xicon"
        onClick={() => {
          setSelectedTemplate(null);
          close();
        }}
      />
      <div className="artwork-options__download-template-templates-container">
        <div
          className={`artwork-options__download-template-templates-container-option ${
            selectTemplate === "story" ? "active" : ""
          }`}
          onClick={() => setSelectedTemplate("story")}
        >
          <div className="artwork-options__download-template-templates-container-story-preview"></div>
          <div className="artwork-options__download-template-templates-container-option-info">
            <p className="artwork-options__download-template-templates-container-option-info_type">
                Story
            </p>
            <p className="artwork-options__download-template-templates-container-option-info_measures">
                1920 x 1080 px
            </p>
          </div>
        </div>
        <div
          className={`artwork-options__download-template-templates-container-option ${
            selectTemplate === "post" ? "active" : ""
          }`}
          onClick={() => setSelectedTemplate("post")}
        >
          <div className="artwork-options__download-template-templates-container-post-preview"></div>
          <div className="artwork-options__download-template-templates-container-option-info">
            <p className="artwork-options__download-template-templates-container-option-info_type">
                Post
            </p>
            <p className="artwork-options__download-template-templates-container-option-info_measures">
                1350 x 1080 px
            </p>
          </div>
        </div>
      </div>

      <ContinueButton
        className={`artwork-options__download-template-templates-continue-button ${
          selectTemplate && "active"
        } `}
        onClick={() => {
          onClick();
        }}
      >
          Next
      </ContinueButton>

    </GenericPopup>
  );
};

export default PopupSelectTemplate;